import listSaga from './listSaga'
import createSaga from './createSaga'
import deleteSaga from './deleteSaga'
import editSaga from './editSaga'
import onePropertySaga from './onePropertySaga'
import getPropertyUploadURLSaga from './getPropertyUploadURLSaga'
import urlPropertySaga from './urlSaga'
import oneUrlSaga from './oneUrlSaga'
import listSearchSaga from './listSearchSaga'

const propertiesSaga = [
    listSaga(),
    createSaga(),
    deleteSaga(),
    editSaga(),
    onePropertySaga(),
    getPropertyUploadURLSaga(),
    urlPropertySaga(),
    oneUrlSaga(),
    listSearchSaga()
]

export default propertiesSaga
